import type { SVGProps } from "react";
import * as React from "react";

const SvgExternalLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 13a1 1 0 1 0-2 0zM3 19H2zM5 6V5zm6 1a1 1 0 1 0 0-2zm4-5a1 1 0 1 0 0 2zm6 1h1a1 1 0 0 0-1-1zm-1 6a1 1 0 1 0 2 0zM9.293 13.293a1 1 0 1 0 1.414 1.414zM17 13v6h2v-6zm0 6a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 19 19zm-.293.707A1 1 0 0 1 16 20v2a3 3 0 0 0 2.121-.879zM16 20H5v2h11zM5 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19V8H2v11zM4 8a1 1 0 0 1 .293-.707L2.879 5.879A3 3 0 0 0 2 8zm.293-.707A1 1 0 0 1 5 7V5a3 3 0 0 0-2.121.879zM5 7h6V5H5zm10-3h6V2h-6zm5-1v6h2V3zm-9.293 11.707 11-11-1.414-1.414-11 11z"
    />
  </svg>
);
export default SvgExternalLink;
